'use client';

import { useRouter } from 'next/navigation';
import { useMemo } from 'react';
import { ContestId } from '@diritto/common/content/contest.constants';
import { ContestStage } from '@diritto/common/content/types/content-contest-info-types';
import { useGetContestStageQuery } from '@/queries/contests/useGetContestStageQuery';
import { tm } from 'utils/tm';

const TABS = [
  {
    key: 'apply',
    title: '픽앤츄 접수 마감',
    subtitle: '안내 다시보기',
    href: '/promotions/2026-pick-and-choo/apply',
    isEnabled: (stage: ContestStage) => stage >= ContestStage.Writing,
  },
  {
    key: 'vote',
    title: '픽앤츄 투표',
    subtitle: '최대 1,000P 받기',
    href: '/promotions/2026-pick-and-choo/vote',
    isEnabled: (stage: ContestStage) => stage >= ContestStage.Vote,
  },
  {
    key: 'announced',
    title: '본선 진출작 발표',
    subtitle: '2026년 2월 25일',
    href: '/promotions/2026-pick-and-choo/top10',
    isEnabled: (stage: ContestStage) => stage >= ContestStage.Announced,
  },
] as const satisfies ReadonlyArray<Tab>;

type TabKey = 'apply' | 'vote' | 'announced';

type Tab = {
  key: string;
  title: string;
  subtitle: string;
  href: string;
  isEnabled: (stage: ContestStage) => boolean;
};

export const ContestHeader2026 = ({ tab = 'apply' }: { tab?: TabKey }) => {
  const router = useRouter();
  const { data: res } = useGetContestStageQuery(ContestId.Contest2026);
  const stage = useMemo(() => (res?.contestStage.stage as ContestStage) ?? ContestStage.Unknown, [res?.contestStage]);

  return (
    <div className="w-full h-[91px] p-2 bg-[#0c0c0c] flex justify-center items-center gap-2.5">
      <div className="w-full sm:max-w-[390px] self-stretch p-1.5 bg-white rounded-[122px] justify-center items-center inline-flex">
        {TABS.map(({ key, title, subtitle, href, isEnabled }) => {
          const isSelected = tab === key;
          const enabled = isEnabled(stage);

          return (
            <div
              key={key}
              className={tm(
                'grow shrink basis-0 h-[63px] rounded-[112px] flex-col justify-center items-center gap-[3px] inline-flex',
                isSelected ? 'bg-[#FFDB59]' : 'bg-white',
                enabled ? 'cursor-pointer' : '',
              )}
              onClick={() => enabled && router.push(href)}>
              <div
                className={tm('text-center text-xxs font-medium', enabled ? 'text-black' : 'text-gray-800 opacity-80')}>
                {title}
              </div>
              <div
                className={tm(
                  'text-center text-xxxs font-medium',
                  enabled ? 'text-black opacity-40' : 'text-gray-800 opacity-80',
                )}>
                {subtitle}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
